// extracted by mini-css-extract-plugin
export var icon = "_bt-3";
export var subtitle = "_bt-2";
export var title = "_bt-1";
export var value = "_bt-0";